<script>
	//@ts-nocheck
	import { onMount, afterUpdate } from 'svelte';
	import ElectionCard from './ElectionCard.svelte';

	export let districts = [];
	export let selectedPcode = null;
	export let hoveredPcode = null;
	export let onCardClick = () => {};

	$: console.log('districts', districts)

	let scrollContainer;
	let searchTerm = '';

	// Auto-scroll to selected card when selectedPcode changes (only on click, not hover)
	$: if (selectedPcode && scrollContainer) {
		const element = scrollContainer.querySelector(`[data-pcode="${selectedPcode}"]`);
		if (element) {
			element.scrollIntoView({ 
				behavior: 'smooth', 
				block: 'center' 
			});
		}
	}

	// Group districts by their pcode to get unique districts
	$: uniqueDistricts = districts.reduce((acc, district) => {
		const pcode = district.properties?.result?.[0]?.pcode;
		if (pcode && !acc.find(d => d.properties?.result?.[0]?.pcode === pcode)) {
			acc.push(district);
		}
		return acc;
	}, []);

	// Sort districts by DUN_code for consistent ordering
	$: sortedDistricts = uniqueDistricts.sort((a, b) => {
		const dunCodeA = a.properties?.result?.[0]?.DUN_code || '';
		const dunCodeB = b.properties?.result?.[0]?.DUN_code || '';
		// Extract numeric part from DUN_code (e.g., "N.01" -> 1, "N.10" -> 10)
		const numA = parseInt(dunCodeA.replace(/[^\d]/g, '')) || 0;
		const numB = parseInt(dunCodeB.replace(/[^\d]/g, '')) || 0;
		return numA - numB;
	});

	// Filter districts based on search term
	$: filteredDistricts = searchTerm.trim() === '' 
		? sortedDistricts 
		: sortedDistricts.filter(district => {
			const seatName = district.properties?.result?.[0]?.seat_name_en || '';
			return seatName.toLowerCase().includes(searchTerm.toLowerCase());
		});
</script>

<div class="flex flex-col h-full bg-gray-50 election-card-panel-wrapper">
	<!-- Search Bar -->
	<div class="p-4 bg-white border-b border-gray-200">
		<input
			type="text"
			placeholder="Search by constituency name..."
			bind:value={searchTerm}
			class="px-4 py-2 w-full rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
		/>
	</div>
	
	<div 
		class="p-4 election-card-panel"
		bind:this={scrollContainer}
	>
		<div class="space-y-3">
			{#each filteredDistricts as district}
				{@const pcode = district.properties?.result?.[0]?.pcode}
				{@const isSelected = pcode === selectedPcode}
				{@const isHovered = pcode === hoveredPcode}
				<div 
					data-pcode={pcode}
				>
					<ElectionCard 
						data={district.properties} 
						{isSelected}
						{isHovered}
						onClick={() => onCardClick(pcode)}
					/>
				</div>
			{/each}
		</div>
	</div>
</div>

<style>
	.election-card-panel-wrapper {
		min-height: 0; /* Allows flex child to shrink below content size */
		height: 100%;
		overflow: hidden;
		width: 100%;
		max-width: 100%;
	}
	
	.election-card-panel {
		scroll-behavior: smooth;
		height: 100%;
		overflow-y: auto;
		width: 100%;
	}
	
	/* Custom scrollbar styling */
	.election-card-panel::-webkit-scrollbar {
		width: 6px;
	}
	
	.election-card-panel::-webkit-scrollbar-track {
		background: #f1f5f9;
		border-radius: 3px;
	}
	
	.election-card-panel::-webkit-scrollbar-thumb {
		background: #cbd5e1;
		border-radius: 3px;
	}
	
	.election-card-panel::-webkit-scrollbar-thumb:hover {
		background: #94a3b8;
	}
	
	/* Mobile adjustments */
	@media (max-width: 767px) {
		.election-card-panel-wrapper {
			width: 100%;
			max-width: 100%;
		}
		
		.election-card-panel {
			width: 100%;
			padding: 0.75rem;
		}
	}
</style>
